angular.module('invoice')
    .component('invoiceWorkflowDashboard', {
        templateUrl: 'app/invoice/dashboard/dashboard.html',
        controller: function ($scope, $http, Principal, InvoiceConst) {
            this.items = []
            this.statuses = []
            this.filter = null

            this.$onInit = () => {
                this.refreshPermissionsAndData()
                this.unwatchAuthenticationChanged = $scope.$on('authenticationChanged', () => this.refreshPermissionsAndData())
                this.unwatchInvoiceUpdated = $scope.$on(InvoiceConst.eventUpdate, () => this.loadStatistics())
            }

            this.$onDestroy = () => {
                if (angular.isFunction(this.unwatchAuthenticationChanged)) {
                    this.unwatchAuthenticationChanged()
                }
                if (angular.isFunction(this.unwatchInvoiceUpdated)) {
                    this.unwatchInvoiceUpdated()
                }
            }

            this.refreshPermissionsAndData = () => {
                Principal.hasAnyAuthorityPromise(['ROLE_INVOICE_DOCUMENTS_MODULE']).then(hasAccess => {
                    if (!hasAccess) {
                        this.items = []
                        this.statuses = []
                        this.filter = null
                        return
                    }
                    this.loadStatistics()
                })
            }

            this.loadStatistics = () => {
                return $http.get('/crm/api/invoice/dashboard')
                    .then(response => {
                        const data = response.data || {}
                        this.statuses = data.statuses || []
                        this.filter = data.filter
                        this.items = (data.statistics || []).map(item => this.toDashboardItem(item))
                    })
                    .catch(() => {
                        this.items = []
                        this.statuses = []
                        this.filter = null
                    })
            }

            this.toDashboardItem = item => {
                const assigned = item.user && item.user.id
                const statusCounts = item.statusCounts || {}
                const cells = this.statuses.map(status => ({
                    status: status,
                    count: statusCounts[status] || 0,
                    filters: {
                        filter: this.filter,
                        status: [status],
                        worker: assigned ? item.user.id : undefined,
                        workerMissing: assigned ? undefined : 1
                    }
                }))

                return angular.extend({}, item, {
                    key: assigned ? `worker-${item.user.id}` : 'worker-unassigned',
                    cells: cells
                })
            }
        }
    })
